export { CategoryFacet } from './CategoryFacet';
export type { CategoryFacetProps } from './CategoryFacet.types';
